import React from "react";
import styles from "../../styles";
import FileExplorerGUI from "../FileExplorerGUI";
import Window from "../Window";

class WindowedFileExplorer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: null,
      height: null,
    };
    this.resizeWindow = this.resizeWindow.bind(this);
  }

  resizeWindow(width, height) {
    this.setState((state) => ({
      ...state,
      width,
      height,
    }));
  }

  render() {
    return (
      <Window
        id={this.props.id}
        top={0}
        left={0}
        name={"File Explorer"}
        onClick={this.props.onFocus}
        onCancel={this.props.closeWindow}
        onResize={this.resizeWindow}
      >
        <div style={{ ...styles.column, alignSelf: "stretch" }}>
          <FileExplorerGUI
            fileSystem={this.props.fileSystem}
            setCodeEditorRoot={this.props.setCodeEditorRoot}
            setInstallHash={this.props.setInstallHash}
            root={this.props.root}
            dims={{ width: this.state.width, height: this.state.height }}
            openWindow={this.props.openWindow}
            addCurrentFile={this.props.addCurrentFile}
            addCurrentWindow={this.props.addCurrentWindow}
            closeCurrentWindow={this.props.closeCurrentWindow}
            closeCurrentFile={this.props.closeCurrentFile}
            saveCurrentFile={this.props.saveCurrentFile}
            systemData={this.props.systemData}
          />
        </div>
      </Window>
    );
  }
}

export default WindowedFileExplorer;
